module.exports = __webpack_public_path__ + "static/media/back-2.79d30428.png";